export default __webpack_public_path__ + "static/media/icone-ajuda.619b1776.svg";